import { PatientProps } from '../../../contexts/PatientContext';
import { EligibilityPlanProps, usePaymentContext } from '../../../contexts/PaymentContext';
import { Payment } from '../../../models/Schedule';
import { PAYMENT_TYPE } from '../../../utils/constants';
import { verifyEligibility } from '../../../modules/eligibility';

export const useEligibility = () => {
  const { setEligibilityPlans } = usePaymentContext();

  const makeB2BPayment = (plan: EligibilityPlanProps) =>
    ({
      type: PAYMENT_TYPE.B2B,
      eligibility: {
        idInsurance: plan.id_convenio,
        idCustomer: plan.id_cliente,
        codInsurance: plan.cod_convenio,
        codPlan: plan.cod_plano,
        codOffice: plan.cod_escritorio,
        plan: plan.nome,
        image: plan.image
      }
    } as Payment);

  async function validateEligibilityPlans({ productId, patient }: { productId: string; patient: PatientProps }) {
    const { data, error } = await verifyEligibility({
      eligibilityType: 'PRODUCT',
      document: patient.document,
      documentType: patient.documentType,
      itemId: productId,
      birthDate: patient.birthDate
    });

    if (error || data.length === 0) return;

    if (data.length > 0) {
      setEligibilityPlans(data);
      return data.map(item => makeB2BPayment(item));
    }
  }

  return { validateEligibilityPlans };
};
